import styled, { css } from 'styled-components';

import STANDARDDEFAULTSRC from 'assets/logo-tsl.svg';
import type { COLOR_THEME } from 'constants/colorThemes';
import type ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing, colorFilterUsage } from 'stylesheetB2b';
import { ALLEXTENSIONS, getLogoModel, STANDARDLOGOKEY } from 'types/logo/logo';

import { ReactComponent as Logo } from 'assets/logo-bam-karaokebox.svg';

export const AdminLogoBAM = styled(Logo)`
  position: absolute;
  height: ${getSpacing(9)};
  top: ${getSpacing(8.4)};
`;


import buildLogo from '../Logo';

const logoModel = getLogoModel(STANDARDLOGOKEY, ALLEXTENSIONS, STANDARDDEFAULTSRC);
const TslLogoImg = buildLogo(logoModel);

export const LayoutContainer = styled.div<{
  colorTheme: COLOR_THEME;
  $on: boolean;
  colors: ColormapInterface;
}>`
  height: 100%;
  display: ${(props) => (props.$on ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ colorTheme, colors }) =>
    css`
      background-color: ${colors[colorTheme].layoutBackground};
    `}
`;
LayoutContainer.displayName = 'LayoutContainer';

export const StyledTslLogo = styled(TslLogoImg)`
  flex-shrink: 0;
  filter: ${colorFilterUsage.tslLogo};
  pointer-events: none;
  max-width: ${getSpacing(118)};
  height: ${getSpacing(20)};
  width: auto;
`;
StyledTslLogo.displayName = 'StyledTslLogo';

export const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  max-width: ${getSpacing(100)};
  aspect-ratio: 1 / 1.25;
`;
ChildrenContainer.displayName = 'ChildrenContainer';
